/**
 * Log an error to both console and DataDog.
 *
 * The console.error call is automatically intercepted by dataDogLib
 * and forwarded to Datadog with structured context (Error objects and
 * plain-object context are extracted automatically).
 *
 * @param message - A descriptive message about what failed
 * @param error - The error object (if available)
 * @param context - Additional context to help debug the issue
 *
 * @example
 * ```typescript
 * try {
 *   await createScan(data);
 * } catch (error) {
 *   logError("Failed to create scan", error, { scanTemplateId: data.templateId });
 *   showToast("Unable to create scan. Please try again.", "error");
 * }
 * ```
 */
export const logError = (message: string, error?: Error | unknown, context?: Record<string, any>) => {
  // console.error is intercepted by dataDogLib and forwarded to Datadog
  // Pass structured args so the interceptor can extract Error and context
  console.error(message, error, context);
};

// hack to get logging over to packages/publishable/kai-pro-api-react-state/src/contexts/syncing/Models/loggerHelper.ts
// TODO: solve the routing problem and do this in a cleaner way
if (typeof window !== 'undefined') {
  (window as any).ddLogger = logError;
}
